if (!customElements.get('kj-product-slider')) {
  customElements.define('kj-product-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('ul');
      this.previous = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');
      if (!this.track || !this.previous || !this.next) return;

      this.update = () => {
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= maximum - 1;
      };
      this.move = (event) => {
        const button = event.target.closest('button');
        if (button !== this.previous && button !== this.next) return;
        const first = this.track.children[0];
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: (first.getBoundingClientRect().width + gap) * direction * (button === this.next ? 1 : -1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
      };
      this.addEventListener('click', this.move);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.move);
      this.track?.removeEventListener('scroll', this.update);
      this.observer?.disconnect();
    }
  });
}
